import { ITestimonialSection } from '@/interfaces/homepage';
import { TestimonialCard } from './TestimonialCard';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { useTestimonialAutoplay } from './useTestimonialAutoplay';
import CustomButtonGroupAsArrows from '@/components/CustomButtonGroupAsArrows';

// Must render inside <Swiper> so useSwiper() resolves to the parent instance.
function TestimonialArrows() {
  const swiper = useSwiper();

  return <CustomButtonGroupAsArrows isTestimonial={true} swiper={swiper} dataTestId="testimonial-arrows" className="block" />;
}

export function TestimonialSlider({ content }: Readonly<{ content: ITestimonialSection }>) {
  const { autoplayTime, containerRef } = useTestimonialAutoplay();

  return (
    <div className="relative" data-testid="testimonial-slider-container">
      <Swiper
        className="!p-px"
        modules={[Autoplay]}
        ref={containerRef}
        spaceBetween={24}
        slidesPerView={1}
        loop={content.Items.length > 1}
        autoplay={{ delay: autoplayTime }}
        breakpoints={{
          1024: {
            slidesPerView: 1.125,
            autoplay: { delay: autoplayTime },
          },
        }}
      >
        {content.Items.map((testimonial) => {
          return (
            <SwiperSlide key={testimonial.Id} className="!h-auto" data-testid="testimonial-item">
              <TestimonialCard testimonial={testimonial}>{content.Items.length > 1 && <TestimonialArrows />}</TestimonialCard>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
